/**
 * ModuleLayout — per-module sub-route shell.
 *
 * M3X.WORKSPACE-CLOSURE A2: The per-module title + tab strip is
 * REMOVED. Rail 2 (in WorkspaceShell) is now the sole sub-domain
 * navigation; ContentTabStrip is the sole screen tab strip. The
 * Breadcrumb in WorkspaceTopBar shows the module / sub-domain /
 * screen titles. Rendering them again here was the source of Amer's
 * screenshot complaint #1 — sub-domains appearing as page tabs.
 *
 * ModuleLayout now reduces to `<Outlet />` so existing App.tsx
 * `<Route element={<{Module}Module />}>` wrappers remain functional
 * without churning every route declaration.
 */

import { Outlet } from "react-router-dom";
import type { LucideIcon } from "lucide-react";

import type { ModuleTab } from "./ui/ModuleTabs";


export function ModuleLayout(
  // Props kept for compatibility with ModuleShells.tsx callers.
  // Intentionally unused — Rail 2 + ContentTabStrip + Breadcrumb in
  // WorkspaceShell now own the surfaces this used to render.
  _props: {
    titleKey: string;
    subtitleKey?: string;
    icon?: LucideIcon;
    tabs: ModuleTab[];
    ariaLabel: string;
  },
) {
  return <Outlet />;
}
